import { useState } from 'react';
import Container from '@ui/container/container';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';
import Button from '@ui/buttons/button/button';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { isValidEmail } from '../../utils';

interface ManualAddUserRowProps {
  email: string;
  firstName: string;
  lastName: string;
  onEmailChange: (value: string) => void;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  onDelete?: () => void;
}

const ManualAddUserRow = ({
  email,
  firstName,
  lastName,
  onEmailChange,
  onFirstNameChange,
  onLastNameChange,
  onDelete,
}: ManualAddUserRowProps) => {
  const [emailTouched, setEmailTouched] = useState(false);
  const emailError = emailTouched && email.trim() !== '' && !isValidEmail(email);

  return (
    <Container className="flex-1 flex gap-12 ai-center">
      <div style={{ flex: 2, minWidth: 0 }}>
        <InputWithOverlay
          inputProps={{
            type: 'email',
            value: email,
            onChange: (e) => onEmailChange(e.target.value),
            onBlur: () => setEmailTouched(true),
            placeholder: 'email@domain.com',
            className: 'S2',
          }}
          status={emailError ? 'error' : 'default'}
          inputWidth="100%"
          inputHeight="36px"
        />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <InputWithOverlay
          inputProps={{
            value: firstName,
            onChange: (e) => onFirstNameChange(e.target.value),
            placeholder: 'John',
            className: 'S2',
          }}
          inputWidth="100%"
          inputHeight="36px"
        />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <InputWithOverlay
          inputProps={{
            value: lastName,
            onChange: (e) => onLastNameChange(e.target.value),
            placeholder: 'Doe',
            className: 'S2',
          }}
          inputWidth="100%"
          inputHeight="36px"
        />
      </div>
      <Container width="16px" className="flex jc-center" style={{ flexShrink: 0 }}>
        {onDelete && (
          <Button height="12px" onClick={onDelete} className="clear-button" backgroundColor="transparent">
            <Icon name={ICONS.CLOSE} size={16} />
          </Button>
        )}
      </Container>
    </Container>
  );
};

export default ManualAddUserRow;
